import {LABELS} from '../constants/labels'
import type {AssignedEvent$key} from './__generated__/AssignedEvent.graphql'
import type {UnassignedEvent$key} from './__generated__/UnassignedEvent.graphql'
import {AddedAssigneesRendering} from './AssignedEvent'
import {RemovedAssigneesRendering} from './UnassignedEvent'

type AssignedEventProps = {
  rollupGroup: Record<string, Array<AssignedEvent$key | UnassignedEvent$key>>
}
export function RolledupAssignedEvent({rollupGroup}: AssignedEventProps): React.ReactElement {
  const addedEvents = (rollupGroup['AssignedEvent'] as AssignedEvent$key[]) || []
  const removedEvents = (rollupGroup['UnassignedEvent'] as UnassignedEvent$key[]) || []

  return (
    <>
      <AddedAssigneesRendering queryRefs={addedEvents} selfAssigned={false} rollup />
      {addedEvents.length > 0 && removedEvents.length > 0 && ` ${LABELS.timeline.and} `}
      <RemovedAssigneesRendering queryRefs={removedEvents} selfAssigned={false} rollup />
    </>
  )
}
